import dayjs from "@/plugins/vue-dayjs";

/**
 * 오늘이 속한 기간의 시작일·종료일.
 *
 * 기본값(월간)은 화면과 조회 양쪽에서 똑같이 쓰여야 한다 — 한쪽만 어긋나면
 * 주소창에는 기간이 없는데 목록은 다른 기간을 보여주는 상태가 된다.
 *
 * @param {'year'|'month'|'day'} [unit="month"]
 * @returns {[string, string]}
 */
export const initDuration = (unit = "month") => [
    //
    dayjs.tz().startOf(unit).format("YYYY-MM-DD"),
    dayjs.tz().endOf(unit).format("YYYY-MM-DD"),
];

export default initDuration;
